<ion-app [ngClass]="{'offline-mode': db.isOfflineMode}"><!--
  <ion-split-pane>
    <ion-menu>
      <ion-header>
        <ion-toolbar [color]="color">
          <ion-title>Menu</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages">
            <ion-item [routerDirection]="'root'" [routerLink]="[p.url]">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>
                {{p.title}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    
  </ion-split-pane>-->

  <div *ngIf="updateService.updateAvailable || updateService.capgoUpdateAvailable" class="update-pill"
    (click)="updateService.reloadApp()">
    <span class="dot"></span>
    <span>Aggiorna versione</span>
  </div>

  <div *ngIf="showNetworkMsg && networkStatus == 'offline'" class="update-pill offline">
    <span class="dot red"></span>
    <span>Nessuna connessione</span>
  </div>

  <div *ngIf="showNetworkMsg && networkStatus == 'slow'" class="update-pill warn">
    <span class="dot yellow"></span>
    <span>Connessione lenta</span>
  </div>

  <ion-fab vertical="bottom" horizontal="end" *ngIf="fab.visible | async">
    <ion-fab-button class="scroll-fab" (click)="fab.scroll()">
      <ion-icon [name]="(fab.isAtBottom | async) ? 'arrow-up' : 'arrow-down'">
      </ion-icon>
    </ion-fab-button>
  </ion-fab>

  <ion-router-outlet main></ion-router-outlet>
  <!--<app-spinner *ngIf="spinnerService.isLoading"></app-spinner>-->
</ion-app>